import LinkComponent from './Link.vue';
export const Link = LinkComponent;
export default Link;
